export const MANHATTAN_CENTER = {
  lat: 40.78343,
  lng: -73.96625,
};

export const BROOKLYN_CENTER = {
  lat: 40.670002,
  lng: -73.949997,
};

export const QUEENS_CENTER = {
  lat: 40.732054,
  lng: -73.889417,
};

export const MANHATTAN_MARKERS = [
  {
    lat: 40.72584,
    lng: -73.97749,
    place: "Alphabet City",
  },
  {
    place: "NoHo",
    lat: 40.72865,
    lng: -73.99255,
  },
  {
    place: "Central Park",
    lat: 40.78255,
    lng: -73.96558,
  },
  {
    place: "Hell's Kitchen",
    lat: 40.76362,
    lng: -73.99115,
  },
  {
    place: "East Village",
    lat: 40.72927,
    lng: -73.98736,
  },
  {
    place: "Garment District",
    lat: 40.7547,
    lng: -73.99163,
  },
  {
    place: "Greenwich Village",
    lat: 40.73357,
    lng: -74.00274,
  },
  {
    place: "Lenox Hill",
    lat: 40.76759,
    lng: -73.96762,
  },
  {
    place: "Manhattanville",
    lat: 40.81694,
    lng: -73.95583,
  },
  {
    place: "Morningside Heights",
    lat: 40.80833,
    lng: -73.96333,
  },
  {
    place: "Nolita",
    lat: 40.72288,
    lng: -73.99529,
  },
  {
    place: "Roosevelt Island",
    lat: 40.76143,
    lng: -73.95097,
  },
  {
    place: "The Battery",
    lat: 40.70387,
    lng: -74.01343,
  },
  {
    place: "Sutton Place",
    lat: 40.75793,
    lng: -73.96164,
  },
  {
    place: "Midtown East",
    lat: 40.75714,
    lng: -73.97188,
  },
  {
    place: "Vinegar Hill",
    lat: 40.70371,
    lng: -73.98226,
  },
  {
    place: "Yorkville",
    lat: 40.77622,
    lng: -73.94921,
  },
  {
    place: "Chelsea",
    lat: 40.7465,
    lng: -74.00137,
  },
  {
    place: "Columbus Circle",
    lat: 40.76805,
    lng: -73.98295,
  },
  {
    place: "Financial District",
    lat: 40.70714,
    lng: -74.01066,
  },
  {
    place: "Governors Island",
    lat: 40.68945,
    lng: -74.01679,
  },
  {
    place: "Hamilton Heights",
    lat: 40.82596,
    lng: -73.94969,
  },
  {
    place: "Hudson Yards",
    lat: 40.75666,
    lng: -74.00033,
  },
  {
    place: "Little Italy",
    lat: 40.71914,
    lng: -73.99703,
  },
  {
    place: "Meatpacking District",
    lat: 40.74099,
    lng: -74.00742,
  },
  {
    place: "Murray Hill",
    lat: 40.74816,
    lng: -73.97859,
  },
  {
    place: "NoMad",
    lat: 40.74492,
    lng: -73.98815,
  },
  {
    place: "SoHo",
    lat: 40.72459,
    lng: -74.00191,
  },
  {
    place: "TriBeCa",
    lat: 40.71627,
    lng: -74.00863,
  },
  {
    place: "Upper East Side",
    lat: 40.77357,
    lng: -73.95655,
  },
  {
    place: "Washington Heights",
    lat: 40.84171,
    lng: -73.93936,
  },
  {
    place: "Carnegie Hill",
    lat: 40.78404,
    lng: -73.95825,
  },
  {
    place: "Chinatown",
    lat: 40.71575,
    lng: -73.99703,
  },
  {
    place: "East Harlem",
    lat: 40.79574,
    lng: -73.93892,
  },
  {
    place: "Flatiron District",
    lat: 40.74106,
    lng: -73.9897,
  },
  {
    place: "Gramercy Park",
    lat: 40.73793,
    lng: -73.98551,
  },
  {
    place: "Harlem",
    lat: 40.81155,
    lng: -73.94648,
  },
  {
    place: "Randalls and Wards Islands",
    lat: 40.79306,
    lng: -73.92528,
  },
  {
    place: "StuyTown",
    lat: 40.73197,
    lng: -73.97772,
  },
  {
    place: "Tudor City",
    lat: 40.74888,
    lng: -73.97166,
  },
  {
    place: "Upper West Side",
    lat: 40.78701,
    lng: -73.97537,
  },
  {
    place: "West Village",
    lat: 40.73401,
    lng: -74.00299,
  },
];

export const BROOKLYN_MARKERS = [
  {
    place: "Bay Ridge",
    lat: 40.62643,
    lng: -74.03294,
  },
  {
    place: "Borough Park",
    lat: 40.63399,
    lng: -73.99681,
  },
  {
    place: "Brownsville",
    lat: 40.66308,
    lng: -73.90952,
  },
  {
    place: "Carroll Gardens",
    lat: 40.67953,
    lng: -73.99917,
  },
  {
    place: "Columbia Street Waterfront District",
    lat: 40.68795,
    lng: -74.00271,
  },
  {
    place: "Downtown",
    lat: 40.69008,
    lng: -73.98362,
  },
  {
    place: "East New York",
    lat: 40.66677,
    lng: -73.88236,
  },
  {
    place: "Gowanus",
    lat: 40.67393,
    lng: -73.99091,
  },
  {
    place: "Kensington",
    lat: 40.63797,
    lng: -73.97419,
  },
  {
    place: "Prospect Heights",
    lat: 40.67793,
    lng: -73.96655,
  },
  {
    place: "Prospect Park South",
    lat: 40.64903,
    lng: -73.9648,
  },
  {
    place: "Sunset Park",
    lat: 40.6451,
    lng: -74.01239,
  },
  {
    place: "Wingate",
    lat: 40.66094,
    lng: -73.93776,
  },
  {
    place: "Bedford Stuyvesant",
    lat: 40.68722,
    lng: -73.94178,
  },
  {
    place: "Brooklyn Heights",
    lat: 40.69601,
    lng: -73.99329,
  },
  {
    place: "Bushwick",
    lat: 40.69443,
    lng: -73.92129,
  },
  {
    place: "Clinton Hill",
    lat: 40.68937,
    lng: -73.9639,
  },
  {
    place: "Crown Heights",
    lat: 40.6681,
    lng: -73.9448,
  },
  {
    place: "DUMBO",
    lat: 40.70317,
    lng: -73.9887,
  },
  {
    place: "Flatbush",
    lat: 40.64092,
    lng: -73.96243,
  },
  {
    place: "Greenpoint",
    lat: 40.72455,
    lng: -73.94186,
  },
  {
    place: "Ocean Hill",
    lat: 40.67803,
    lng: -73.91307,
  },
  {
    place: "Prospect Lefferts Gardens",
    lat: 40.65997,
    lng: -73.95007,
  },
  {
    place: "Red Hook",
    lat: 40.6774,
    lng: -74.00933,
  },
  {
    place: "Williamsburg",
    lat: 40.70811,
    lng: -73.95707,
  },
  {
    place: "Boerum Hill",
    lat: 40.68568,
    lng: -73.98453,
  },
  {
    place: "Brooklyn Navy Yard",
    lat: 40.70218,
    lng: -73.97213,
  },
  {
    place: "Canarsie",
    lat: 40.64014,
    lng: -73.90626,
  },
  {
    place: "Cobble Hill",
    lat: 40.68654,
    lng: -73.99695,
  },
  {
    place: "Ditmas Park",
    lat: 40.64005,
    lng: -73.96426,
  },
  {
    place: "East Flatbush",
    lat: 40.65314,
    lng: -73.93023,
  },
  {
    place: "Fort Greene",
    lat: 40.69149,
    lng: -73.97425,
  },
  {
    place: "Greenwood",
    lat: 40.6501,
    lng: -73.97624,
  },
  {
    place: "Park Slope",
    lat: 40.67232,
    lng: -73.97754,
  },
  {
    place: "Prospect Park",
    lat: 40.6602,
    lng: -73.96901,
  },
  {
    place: "Stuyvesant Heights",
    lat: 40.68239,
    lng: -73.93417,
  },
  {
    place: "Windsor Terrace",
    lat: 40.65393,
    lng: -73.97566,
  },
];

export const QUEENS_MARKERS = [
  {
    place: "Astoria",
    lat: 40.76437,
    lng: -73.92333,
  },
  {
    place: "East Elmhurst",
    lat: 40.76406,
    lng: -73.86741,
  },
  {
    place: "Glendale",
    lat: 40.70276,
    lng: -73.87098,
  },
  {
    place: "Long Island City",
    lat: 40.74469,
    lng: -73.94854,
  },
  {
    place: "Rego Park",
    lat: 40.72557,
    lng: -73.86236,
  },
  {
    place: "Sunnyside Gardens",
    lat: 40.74565,
    lng: -73.91819,
  },
  {
    place: "Blissville",
    lat: 40.73725,
    lng: -73.93244,
  },
  {
    place: "Elmhurst",
    lat: 40.73797,
    lng: -73.88005,
  },
  {
    place: "Hunters Point",
    lat: 40.74207,
    lng: -73.94888,
  },
  {
    place: "Maspeth",
    lat: 40.72932,
    lng: -73.9068,
  },
  {
    place: "Ridgewood",
    lat: 40.71005,
    lng: -73.89718,
  },
  {
    place: "Woodside",
    lat: 40.74538,
    lng: -73.9051,
  },
  {
    place: "Dutch Kills",
    lat: 40.75347,
    lng: -73.93886,
  },
  {
    place: "Forest Hills",
    lat: 40.71932,
    lng: -73.84485,
  },
  {
    place: "Jackson Heights",
    lat: 40.75568,
    lng: -73.88307,
  },
  {
    place: "Middle Village",
    lat: 40.71737,
    lng: -73.88033,
  },
  {
    place: "Sunnyside",
    lat: 40.74332,
    lng: -73.91932,
  },
];
